(ns app.front.view.group.admin.fees.formula.formula-subs
  "Subscriptions for formula test state."
  (:require [app.front.view.group.admin.fees.formula.formula-events :as ff-events]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub ::test-values
  (fn [db [_ entity-id field]]
    (get-in db [::ff-events/formula :test entity-id field :values] {})))


(rf/reg-sub ::test-expression
  (fn [db [_ entity-id field]]
    (get-in db [::ff-events/formula :test entity-id field :expression] "")))


(rf/reg-sub ::test-result
  (fn [db [_ entity-id field]]
    (get-in db [::ff-events/formula :test entity-id field :result])))
